'use es6';

import extractor from '../../../../config/extractor';
export default (() => extractor((config, missingValue) => {
  const pipeline = config.getIn(['pipeline', 'id']);
  return pipeline || missingValue;
}, 'default'));